/**
 * Une barre d'onglets de la console : un onglet = un lien vers son adresse,
 * pour que le bouton retour du navigateur et les favoris fonctionnent.
 * Utilisée pour les onglets d'une section et pour leurs sous-onglets.
 */
import React from 'react';
import { Tab, Tabs } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import type { Onglet } from '../../config/sections';
import { cheminComplet } from './ongletsVisibles';

interface OngletsNiveauProps {
  /** Onglets déjà filtrés par rôle. */
  onglets: Onglet[];
  /** Adresse sous laquelle se trouvent ces onglets. */
  base: string;
  /** Onglet sélectionné. */
  actif: Onglet | undefined;
  /** Libellé lu par les lecteurs d'écran. */
  libelle: string;
  /** Sous-onglets : barre plus discrète. */
  secondaire?: boolean;
}

/** Barre d'onglets défilante ; rien n'est affiché pour un seul onglet. */
const OngletsNiveau: React.FC<OngletsNiveauProps> = ({ onglets, base, actif, libelle, secondaire }) => {
  if (onglets.length < 2) return null;
  return (
    <Tabs
      value={actif?.cle ?? false}
      aria-label={libelle}
      variant="scrollable"
      scrollButtons="auto"
      sx={{ mb: 2, borderBottom: secondaire ? 0 : 1, borderColor: 'divider', minHeight: secondaire ? 40 : 48 }}
    >
      {onglets.map((onglet) => (
        <Tab
          key={onglet.cle}
          value={onglet.cle}
          label={onglet.titre}
          component={RouterLink}
          to={cheminComplet(base, onglet.chemin)}
          sx={secondaire ? { minHeight: 40, textTransform: 'none' } : { textTransform: 'none', fontWeight: 600 }}
        />
      ))}
    </Tabs>
  );
};

export default OngletsNiveau;
